import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgParkedDomain = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-parking-square",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 18,
		height: 18,
		x: 3,
		y: 3,
		rx: 2
	}), /* @__PURE__ */ _jsx("path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9" })]
});
export default SvgParkedDomain;
